import React, { Component, Fragment } from 'react';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { isArray } from 'util';
import { Translate } from '../../contexts/Language';
import { Card, BreadCrumb, Modal, JsonTable, Confirm } from '../../components';
import 'react-datepicker/dist/react-datepicker.css';
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Config } from '../../config';

const beginDateLocal = localStorage.getItem('beginDate');
const endDateLocal = localStorage.getItem('endDate');

export class Deposit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      formData: {
        beginDate: (beginDateLocal ? new Date(beginDateLocal) : new Date()),
        endDate: (endDateLocal ? new Date(endDateLocal) : new Date()),
        status: -5,
        comment: '',
      },
      dataTable: {
        columns: DataTableColumns.deposit,
        rows: [],
      },
      detail: {},
      readOnly: true,
      validation: {
        error: false,
        message: '',
      },
    };

    this.onDetail = this.onDetail.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onEditSave = this.onEditSave.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onSetStatus = this.onSetStatus.bind(this);
  }

  componentDidMount() {
    this.onFilter();
  }

  onFilter() {
    Config.utilities.loadingFetch();

    const { formData, dataTable } = this.state;
    const data = { ...formData };

    const beginDate = new Date(data.beginDate);
    data.beginDate = new Date(beginDate.setDate(beginDate.getDate() + 1));

    Service.Deposit.History(data).then(response => {
      if (response) {
        dataTable.rows = response;

        this.setState({
          dataTable,
        });
      }

      Config.utilities.loadingFetch();
    });
  }

  onDateChange(date) {
    const { formData } = this.state;

    if (date !== null && isArray(date)) {
      [formData.beginDate, formData.endDate] = date;
    } else {
      formData.beginDate = '';
      formData.endDate = '';
    }

    this.setState({
      formData,
    });

    localStorage.setItem('beginDate', formData.beginDate);
    localStorage.setItem('endDate', formData.endDate);
  }

  onChange(value, stateKey) {
    const { formData } = this.state;

    formData[stateKey] = value;

    this.setState({
      formData,
    });

    localStorage.setItem(stateKey, value);
  }

  onConfirm(transactionId) {
    Confirm({
      title: Translate('Are you sure?'),
      type: { warning: true },
      description: Translate('This deposit will be confirmed'),
      onConfirm: () => {
        Config.utilities.loadingFetch();
        Service.Deposit.Confirm({ TransactionId: transactionId, Type: 'deposit' }).then(response => {
          if (response) {
            this.setState({
              readOnly: true,
              modal: false,
              validation: response,
            });

            this.onFilter();
          }

          Config.utilities.loadingFetch();
        });
      },
      onCancel: () => { },
    });
  }

  onDetail(transactionId) {
    Config.utilities.loadingFetch();

    Service.Deposit.Detail({ TransactionId: transactionId }).then(response => {
      if (response) {
        if (response.paymentResponse !== null) {
          response.paymentResponse = JSON.parse(response.paymentResponse);

          if ((!Object.prototype.hasOwnProperty.call(response, 'paymentResponse') && !Object.prototype.hasOwnProperty.call(response, 'requestHeader'))) {
            const { paymentResponse } = response;

            response.paymentResponse = {};
            response.paymentResponse.paymentResponse = paymentResponse;
          }
        }

        if (response.common !== null) {
          response.common = JSON.parse(response.common);
        }

        if (response.requestHeader !== null) {
          response.requestHeader = JSON.parse(response.requestHeader);
        }

        if (response.comment !== null) {
          const comment = JSON.parse(response.comment);
          response.comment = comment.Comment;
        }

        const { formData } = this.state;
        formData.comment = response.comment;

        this.setState({
          detail: response,
          formData,
          modal: true,
        });
      }

      Config.utilities.loadingFetch();
    });
  }

  onCloseModal() {
    this.setState({
      modal: false,
      readOnly: true,
    });
  }

  onCancel(transactionId) {
    Confirm({
      title: Translate('Are you sure?'),
      type: { warning: true },
      description: Translate('This withdrawal will be canceled'),
      onConfirm: () => {
        Config.utilities.loadingFetch();
        Service.Deposit.Cancel({ TransactionId: transactionId, Type: 'deposit' }).then(response => {
          if (response) {
            this.setState({
              readOnly: true,
              modal: false,
              validation: response,
            });

            this.onFilter();
          }

          Config.utilities.loadingFetch();
        });
      },
      onCancel: () => { },
    });
  }

  onEditSave() {
    const { readOnly, formData, detail } = this.state;
    if (readOnly) {
      this.setState({
        readOnly: false,
      });
    } else {
      Config.utilities.loadingFetch();

      Service.Deposit.SaveComment({ TransactionId: detail.transactionId, Comment: formData.comment, Type: 'deposit' }).then(response => {
        if (response) {
          this.setState({
            readOnly: true,
            modal: false,
          });
        }

        Config.utilities.loadingFetch();
      });
    }
  }

  onSetStatus() {
    const { detail } = this.state;

    Confirm({
      title: Translate("Are you sure?"),
      type: { warning: true },
      description: Translate("This deposit status will change to Confirm"),
      onConfirm: () => {
        Config.utilities.loadingFetch();
        Service.Deposit.SetStatus({ 'TransactionId': detail.transactionId, 'Type': "deposit" }).then(response => {

          if (response) {
            this.setState({
              readOnly: true,
              modal: false,
              validation: response
            })
            this.onFilter();
          }

          Config.utilities.loadingFetch();
        });
      },
      onCancel: () => {

      }
    });
  }

  render() {
    const { modal, validation, formData, dataTable, detail, readOnly } = this.state;
    return (
      <>
        <BreadCrumb Title={Translate('Deposit')} Name={Translate('Deposit')} />
        <Modal Title={Translate('Deposit Detail')} Show={modal} onClose={this.onCloseModal} Status={this.state.detail.statusTitle} onSetStatus={this.onSetStatus} Deposit>
          <div className="row mt-1 mb-1" style={{ overflowY: 'auto', overflowX: 'hidden', maxHeight: 'calc(100vh - 300px)' }}>
            <p className="text-muted mb-2 ml-1 col-md-12 font-12">{`${Translate('Transfer Information')} [#${detail.id}]`}</p>
            <div className="col-md-6">
              <dl className="row mb-0 ml-1 dl-striped">
                <dt className="col-sm-6">{Translate('Status')}</dt>
                <dd className="col-sm-6"><span className={`badge pb-1 font-12 payment-status ${detail.statusClass}`}>{Translate(detail.statusTitle)}</span></dd>
                <dt className="col-sm-6">{Translate('Login')}</dt>
                <dd className="col-sm-6">{detail.login}</dd>
                <dt className="col-sm-6">{Translate('PSP')}</dt>
                <dd className="col-sm-6">
                  <img src={`/assets/psp-logo/${detail.transferLogo}`} alt="" width="30" className="mb-1 mr-2" />
                  {detail.transferOption}
                </dd>
                <dt className="col-sm-6">{Translate('Amount')}</dt>
                <dd className="col-sm-6">{`${detail.amount} ${detail.transferCurrency}`}</dd>
                <dt className="col-sm-6">{Translate('Calculated Amount')}</dt>
                <dd className="col-sm-6">{`${(detail.calculatedAmount ? detail.calculatedAmount.toFixed(2) : 0)} ${(detail.accountCurrency || '')}`}</dd>
                <dt className="col-sm-6">{Translate('Exchange Rate')}</dt>
                <dd className="col-sm-6">{detail.exchangeRate}</dd>
              </dl>
            </div>
            <div className="col-md-6">
              <dl className="row mb-0 ml-1 mr-1 dl-striped">
                <dt className="col-sm-6">{Translate('Date')}</dt>
                <dd className="col-sm-6">{detail.insertDate}</dd>
                <dt className="col-sm-6">{Translate('Fullname')}</dt>
                <dd className="col-sm-6">{detail.fullname}</dd>
                <dt className="col-sm-6">{Translate('Meta Status')}</dt>
                <dd className="col-sm-6">{detail.metaStatus}</dd>
                <dt className="col-sm-6">{Translate('Meta Ticket')}</dt>
                <dd className="col-sm-6">{detail.metaTicket}</dd>
                <dt className="col-sm-3">{Translate('Comment')}</dt>
                <dd className="col-sm-9">
                  <div className="input-group input-group-sm">
                    <textarea className="form-control input-sm" type="text" id="comment" name="comment" onChange={e => this.onChange(e.target.value, 'comment')} onFocus={e => e.target.select()} readOnly={readOnly}>
                      {formData.comment}
                    </textarea>
                    <div className="input-group-append hide">
                      <button type="button" className="input-group-text pt-0 pb-0 bg-info text-white btn-sm" id="availableMargin" onClick={() => this.onEditSave()}>
                        {readOnly ? Translate('Edit') : Translate('Save')}
                      </button>
                    </div>
                  </div>
                </dd>
              </dl>
            </div>
            {
              this.state.detail.transferOption === 'UniPayment' && Array.isArray(this.state.detail.common) && (
                <div className="col-12">
                  <a
                    href={`https://sandbox-console.unipayment.io/#/cashier/invoice/detail/${Object.entries(this.state.detail.common[0]).find(([key]) => key === 'invoice_id')[1]}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {Translate("View Invoice on UniPayment Dashboard")} &nbsp;<i className="mdi mdi-open-in-new"></i>
                  </a>
                </div>
              )
            }
            {detail.common != null ?
              (
                <>
                  <p className="text-muted mb-2 mt-3 ml-1 col-md-12 font-12">{Translate('Common Information')}</p>
                  <div className="col-md-12">
                    <dl className="row mb-0 ml-1 dl-striped">
                      {Array.isArray(this.state.detail.common)
                        ? this.state.detail.common.map((item, itemIndex) => (
                          <div className="col-6" key={itemIndex}>
                            {/* {itemIndex > 0 && <hr className="my-2" style={{ borderTop: '1px dashed #dee2e6' }} />} */}
                            {(item.event || item.Event || item.eventName || item.EventName) && (
                              <div className="mb-2">
                                <strong className="text-primary">
                                  {item.event || item.Event || item.eventName || item.EventName}
                                </strong>
                              </div>
                            )}
                            {!item.event && !item.Event && !item.eventName && !item.EventName && (
                              <div className="mb-2">
                                <strong className="text-muted">
                                  {Translate('Event')} #{itemIndex + 1}
                                </strong>
                              </div>
                            )}
                            <div className="row">
                              {Object.keys(item).filter(key =>
                                key !== 'event' && key !== 'Event' && key !== 'eventName' && key !== 'EventName'
                              ).map((key, indexKey) => (
                                <Fragment key={key}>
                                  <dt className="col-sm-6 text-capitalize">{key}</dt>
                                  <dd className="col-sm-6">{item[key]}</dd>
                                </Fragment>
                              ))}
                            </div>
                          </div>
                        ))
                        : Object.keys(this.state.detail.common).map((key, index) => (
                          <Fragment key={index}>
                            <dt className="col-sm-6 text-capitalize">{key}</dt>
                            <dd className="col-sm-6">{this.state.detail.common[key]}</dd>
                          </Fragment>
                        ))}
                    </dl>
                  </div>
                </>
              )
              : ''}
            {detail.paymentResponse ?
              (
                <>
                  <p className="text-muted mb-2 mt-3 ml-1 col-md-12 font-12">
                    {Translate('Payment Response')}
                    <small className="ml-2">{`[${detail.paymentResponseDate}]`}</small>
                  </p>
                  <div className="col-md-12">
                    <JsonTable Data={[detail.paymentResponse.paymentResponse, detail.paymentResponse.requestHeader]} />
                  </div>
                </>
              ) : ''}


            {detail.requestHeader ?
              (
                <>
                  <p className="text-muted mb-2 mt-3 ml-1 col-md-12 font-12 mr-2">{Translate('Request Header')}</p>
                  <div className="col-md-12">
                    <JsonTable Data={[detail.requestHeader]} />
                  </div>
                </>
              ) : ''}
          </div>
        </Modal>
        <Card Title="Customer Deposits" Description="History of deposits">
          <div className="row mb-3">
            <div className="col-md-2">
              <div className="form-group mb-0">
                <label>Status</label>
                <select className="form-control" name="status" id="status" onChange={e => this.onChange(e.target.value, 'status')}>
                  <option value="-5">All</option>
                  <option value="-4">Failed</option>
                  <option value="-3">Error</option>
                  <option value="-2">Temp</option>
                  <option value="-1">Cancel</option>
                  <option value="0">Pending</option>
                  <option value="1">Confirm</option>
                  <option value="2">Manual</option>
                </select>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group mb-0">
                <label>Date Range</label>
                <div>
                  <DateRangePicker
                    className="date-range-picker form-control"
                    onChange={this.onDateChange}
                    value={[formData.beginDate, formData.endDate]}
                    format="dd.MM.yyyy"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group mb-0">
                <label>&nbsp;</label>
                <button type="button" className="btn btn-dark bg-dark btn-block" onClick={() => this.onFilter()}>Filter History</button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className={`col-md-12 ${(validation.error ? '' : 'd-none')}`}>
              <div className="alert alert-danger alert-dismissible fade mb-0 show" role="alert">
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <strong className="mr-1">{Translate('Error !')}</strong>
                {validation.message}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {dataTable.rows.length === 0 ? (
                <div className="alert alert-light" role="alert">
                  <em>
                    <strong className="mr-1">No record!</strong>
                    {Translate('No records found for the filter.')}
                  </em>
                </div>
              ) :
                (
                  <DataTableExtensions columns={dataTable.columns(this.onConfirm, this.onDetail, this.onCancel)} data={dataTable.rows} exportHeaders>
                    <DataTable
                      noHeader
                      defaultSortField="id"
                      defaultSortAsc={false}
                      pagination
                      highlightOnHover
                    />
                  </DataTableExtensions>
                )}
            </div>
          </div>
        </Card>
      </>
    );
  }
}
